import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { treatmentMasterService } from "@project/services/admin/treatment-master.service";
import type { TreatmentMaster } from "@project/types/treatment-master";

const fields: Field[] = [
  {
    name: "name",
    label: "Treatment Name",
    required: true,
    showInTable: true,
    placeholder: "Physiotherapy",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    showInTable: true,
    placeholder: "Physical rehabilitation and mobility support.",
  },
  { name: "is_active", label: "Active", type: "boolean", showInTable: true },
];

export default function Page() {
  return (
    <AdminShell
      title="Treatment Master"
      subtitle="Manage treatment types for admission and medical records"
    >
      <ApiResourceTable<TreatmentMaster>
        title="Treatment"
        labelField="name"
        fields={fields}
        searchFields={["name", "description"]}
        defaultValues={{ is_active: true }}
        list={query => treatmentMasterService.listTreatmentMasterPage(query)}
        create={payload =>
          treatmentMasterService.createTreatmentMaster({
            name: String(payload.name),
            description: payload.description
              ? String(payload.description)
              : undefined,
            is_active: Boolean(payload.is_active),
          })
        }
        update={(id, payload) =>
          treatmentMasterService.updateTreatmentMaster(id, {
            name: payload.name !== undefined ? String(payload.name) : undefined,
            description:
              payload.description !== undefined
                ? String(payload.description)
                : undefined,
            is_active:
              payload.is_active !== undefined
                ? Boolean(payload.is_active)
                : undefined,
          })
        }
        remove={id => treatmentMasterService.deleteTreatmentMaster(id)}
      />
    </AdminShell>
  );
}
